import React from "react";
import { useSnapshot } from "valtio";
import { StyledLabel, StyledModal } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { t } from "i18next";

import { setIsDeleteModalOpened, store } from "../Website/CoverPage/store";
import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { fileStore, setFileStore } from "../fileStore";

export function DeleteModal({ section }: any): JSX.Element {
    const { isDeleteModalOpened, deletedId, path } = useSnapshot(store);

    function handleDeleteItemOnClickEvent() {
        let template =
            templateActions.getNestedObject(path) !== null
                ? JSON.parse(
                      JSON.stringify(templateActions.getNestedObject(path))
                  )
                : [];
        const localData = section !== "Section1" ? [...template] : [];

        // Revoke blob URL of the deleted item
        if (section === "Section1") {
            const sectionData = templateActions.getNestedObject(path);
            const itemData = sectionData?.[deletedId as string];
            if (itemData) {
                ["Desktop", "Mobile"].forEach((device) => {
                    const url = itemData[device]?.Url;
                    if (url?.startsWith("blob:")) {
                        URL.revokeObjectURL(url);
                    }
                });
            }
        } else {
            const deleted = localData.find(
                (item: any) => item.Rank === deletedId
            );
            if (deleted?.Pub?.Url?.startsWith("blob:")) {
                URL.revokeObjectURL(deleted.Pub.Url);
            }
        }

        const newData =
            section === "Section1"
                ? {}
                : localData
                      .filter((item: any) => item.Rank !== deletedId)
                      .map((el: any, key: number) => {
                          return { ...el, Rank: key + 1 };
                      });
        templateActions.updateTemplate(path, newData);
        let finalFiles = handleDeleteFromFiles();
        setFileStore(finalFiles);
        setIsDeleteModalOpened(section, false);
    }

    function handleDeleteFromFiles() {
        let stringPath = path.join(".");
        let exactPath = [...path, deletedId].join(".");
        let newObj = Object.fromEntries(
            Object.entries(fileStore).filter(([key]) => key !== exactPath)
        );
        let finalFiles = Object.keys(newObj).reduce((acc: any, key: any) => {
            let condition1 = key.slice(0, -2) === stringPath;
            let condition2 = key[key.length - 1] > deletedId;
            if (condition2 && condition1) {
                let newKey = `${key.slice(0, -1)}${
                    Number(key[key.length - 1]) - 1
                }`;
                acc[newKey] = fileStore[key];
            } else {
                acc[key] = fileStore[key];
            }
            return acc;
        }, {});
        return finalFiles;
    }

    return (
        <StyledModal
            toggle={() => setIsDeleteModalOpened(section, false)}
            isOpen={isDeleteModalOpened[section]}
            centered
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsDeleteModalOpened(section, false);
                }}
            >
                <span
                    className="text-uppercase"
                    style={{
                        fontFamily: "Segoe UI Semibold",
                        color: "#2b2828",
                        fontSize: "20px",
                    }}
                >
                    {t("Delete an item")}
                </span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="d-flex justify-content-center pl-3 m-0">
                    {t("Do you want to confirm the delete of this element")}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomMainColorButton
                    outline={true}
                    variant="primary"
                    onClick={handleDeleteItemOnClickEvent}
                    rounded={true}
                >
                    {t("Delete")}
                </CustomMainColorButton>

                <CustomMainColorButton
                    rounded={true}
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsDeleteModalOpened(section, false);
                    }}
                >
                    {t("Cancel")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
